export default "/images/logo.svg?33fa4e67624b1b0963ad568895f6b881";